var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Link } from 'react-router-dom';
import { ClickableDisabledStyled, ClickableStyled } from './clickable.component.style';
export var Clickable = function (props) {
    var block = props.block, disabled = props.disabled, otherProps = __rest(props, ["block", "disabled"]);
    // https://developers.google.com/web/tools/lighthouse/audits/noopener
    var toProps = props.to ? { to: props.to, as: Link, rel: props.target === '_blank' ? 'noopener' : undefined } : null;
    return disabled ? (React.createElement(ClickableDisabledStyled, { block: block }, props.children)) : (React.createElement(ClickableStyled, __assign({}, toProps, otherProps, { block: block })));
};
